import type { ErrorList, PageEnvelope } from "../types";

export class CustomError<T = unknown> extends Error {
  errorCode: ErrorList | null;
  meta?: T;
  constructor(message: string | null, errorCode: ErrorList | null, meta?: T) {
    super(message ?? "");
    this.errorCode = errorCode;
    this.meta = meta;
  }
}

export class PageEnvelopeResponseError<T> extends Error {
  res: Response;
  meta?: T;
  constructor(message: string, res: Response, meta?: T) {
    super(message);
    this.res = res;
    this.meta = meta;
  }
}

export const createPageEnvelopeResponseHandlerOld = <T>(meta: T) => {
  return async function pageEnvelopeResponseHandler<U>(
    res: Response
  ): Promise<U> {
    if (res.ok) {
      try {
        return res.json();
      } catch (e) {
        throw new PageEnvelopeResponseError("res.json failed", res, meta);
      }
    }

    throw new PageEnvelopeResponseError(
      "Unknown error occurs (res.ok = false)",
      res,
      meta
    );
  };
};

export const createPageEnvelopeResponseHandler = <TData, TMeta>(
  meta: TMeta
) => {
  return async function pageEnvelopeResponseHandler(
    res: Response
  ): Promise<PageEnvelope<TData, TMeta>> {
    if (res.ok) {
      try {
        return (await res.json()) as PageEnvelope<TData, TMeta>;
      } catch (e) {
        throw new PageEnvelopeResponseError("res.json failed", res, meta);
      }
    }

    throw new PageEnvelopeResponseError(
      "Unknown error occurs (res.ok = false)",
      res,
      meta
    );
  };
};
